var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategyIncomeGeneration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.18522 15.4352C0.827258 15.7932 0.827258 16.3734 1.18522 16.7314L2.10188 17.6481C2.45984 18.006 3.04009 18.006 3.39805 17.6481L8.24997 12.7962L11.2685 15.8147C11.6265 16.1727 12.2068 16.1727 12.5647 15.8147L17.4166 10.9628L18.6019 12.1481C18.8448 12.391 19.2028 12.4776 19.5296 12.3731C19.8568 12.2682 20.0979 11.9895 20.1543 11.6508L21.0709 6.15078C21.1195 5.85883 21.0242 5.56136 20.8147 5.3519C20.6053 5.14245 20.3078 5.04712 20.0158 5.0957L14.5158 6.01237C14.1771 6.06874 13.8985 6.30983 13.7935 6.63708C13.689 6.96387 13.7756 7.32182 14.0185 7.56474L15.2038 8.74999L11.9166 12.0372L8.89805 9.01857C8.54009 8.66061 7.95984 8.66061 7.60188 9.01857L1.18522 15.4352Z",
    fill: "#523FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyIncomeGeneration);
export default __webpack_public_path__ + "static/media/strategy-income-generation.db1d968fa457cf18a1ad226c736ebf30.svg";
export { ForwardRef as ReactComponent };